<template>
  <multi-chart-box :data="chartData"
                   :chart-options="chartOptions"
                   :data-labels="dataLabels"
                   :interval="interval"
                   :loading="loading"
                   :bar-chart-filter-options="barChartFilterOptions"
                   :line-chart-filter-options="lineChartFilterOptions"
                   sync-chart-legends
                   @reload="reloadData"
  />
</template>

<script>
import MultiChartBox from '@/components/Dashboard/MultiChartBox';
import { cloneDeep } from 'lodash';

export default {
  name: 'PropertyMultiChart',
  components: {
    MultiChartBox,
  },
  props: {
    data: {
      type: [Array, Object],
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    interval: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      test: false,
      priorities: null,
      chartOptions: {
        barChart: {
          colors: ['#00D2B4', '#FFA600', '#FA6F86', '#638BC2', '#C388BB'],
          xaxis: {
            type: 'category',
            categories: [],
            labels: {
              style: {
                fontSize: '8px',
                cssClass: 'uppercase-axis',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '8px',
              },
            },
          },
          legend: {
            show: false,
          },
        },
        lineChart: {
          colors: ['#00D2B4', '#FFA600', '#FA6F86', '#638BC2', '#C388BB'],
          xaxis: {
            type: 'category',
            categories: [],
            labels: {
              style: {
                fontSize: '8px',
                cssClass: 'uppercase-axis',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                fontSize: '8px',
              },
            },
          },
          legend: {
            show: false,
          },
          markers: {
            size: 4,
            colors: '#FFFFFF',
            strokeColors: ['#00D2B4', '#FFA600', '#FA6F86', '#638BC2', '#C388BB'],
          },
        },
        table: {
          columnDefs: [],
          gridOptions: {},
          gridApi: null,
          columnApi: null,
          rowHeight: 47.5,
          rowData: [],
        },
      },
      dataLabels: [
        {
          id: 1,
          name: 'LEVEL 1',
        },
        {
          id: 2,
          name: 'LEVEL 2',
        },
        {
          id: 3,
          name: 'LEVEL 3',
        },
        {
          id: 'unknown',
          name: 'UNKNOWN',
        },
      ],
    }
  },
  computed: {
    chartData() {
      if (!this.data) {
        return;
      }

      return this.data;
    },
    barChartFilterOptions() {
      if (!this.dataLabels) {
        return [];
      }

      const colors = this.chartOptions.barChart.colors;

      return this.dataLabels.map((item, key) => {
        return {
          formName: 'bar-chart-data-select',
          formValue: item.id,
          label: item.name,
          value: 0,
          checked: true,
          color: colors[key],
        }
      });
    },
    lineChartFilterOptions() {
      // Clone deep this if you want them to not sync their options
      return this.barChartFilterOptions;

      if (!this.dataLabels) {
        return [];
      }

      const colors = this.chartOptions.barChart.colors;

      const total = [{
        formName: 'line-chart-data-select',
        formValue: 0,
        label: 'Total',
        value: 0,
        checked: true,
        color: colors[0],
      }];

      const options = this.dataLabels.map((item, key) => {
        let index = key+1;
        return {
          formName: 'line-chart-data-select',
          formValue: item.id,
          label: item.name,
          value: 0,
          checked: true,
          color: colors[index],
        }
      });

      return [...total, ...options];
    },
  },
  created() {

  },
  methods: {
    async reloadData(interval) {
      this.$emit('reload', interval);
    }
  }
};
</script>

<style scoped>

</style>
